import { Box, Heading, Stack, Text } from '@chakra-ui/react';

const HERO_NOISE =
  'url("data:image/svg+xml,%3Csvg viewBox=%270 0 180 180%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cfilter id=%27noise%27%3E%3CfeTurbulence type=%27fractalNoise%27 baseFrequency=%270.9%27 numOctaves=%274%27 stitchTiles=%27stitch%27/%3E%3C/filter%3E%3Crect width=%27100%25%27 height=%27100%25%27 filter=%27url(%23noise)%27 opacity=%270.65%27/%3E%3C/svg%3E")';

export function ReimbursementHeroSection() {
  return (
    <Box
      alignItems='center'
      background='linear-gradient(-71.3deg, #021031 28%, #00298C 100%)'
      color='white'
      display='flex'
      minHeight='250px'
      overflow='hidden'
      paddingX={{ base: 6, md: 10 }}
      paddingY={{ base: 12, md: 10 }}
      position='relative'
      _before={{
        backgroundImage: HERO_NOISE,
        backgroundPosition: 'top left',
        backgroundSize: '180px 180px',
        content: '""',
        inset: 0,
        mixBlendMode: 'overlay',
        opacity: 0.2,
        pointerEvents: 'none',
        position: 'absolute',
      }}
    >
      <Stack alignItems='center' gap={4} position='relative' textAlign='center' width='100%'>
        <Heading
          as='h1'
          fontFamily='heading'
          fontSize={{ base: '40px', md: '54px' }}
          fontWeight='600'
          letterSpacing='-0.02em'
          lineHeight='1.1'
        >
          How to expense Udacity
        </Heading>
        <Text fontFamily='body' fontSize='18px' lineHeight='1.5'>
          Get reimbursed for your subscription
        </Text>
      </Stack>
    </Box>
  );
}
